import { render } from "./TaikyoNotificationCheckCard.vue?vue&type=template&id=2ebb7e1c&scoped=true&ts=true"
import script from "./TaikyoNotificationCheckCard.vue?vue&type=script&lang=ts"
export * from "./TaikyoNotificationCheckCard.vue?vue&type=script&lang=ts"

import "./TaikyoNotificationCheckCard.vue?vue&type=style&index=0&id=2ebb7e1c&scoped=true&lang=css"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ebb7e1c"]])

export default __exports__
import QCard from 'quasar/src/components/card/QCard.js';
import QCardSection from 'quasar/src/components/card/QCardSection.js';
import QSeparator from 'quasar/src/components/separator/QSeparator.js';
import qInstall from "../../../../../node_modules/@quasar/app-webpack/lib/loaders/runtime.auto-import.js";
qInstall(script, 'components', {QCard,QCardSection,QSeparator});
